import {
	Card,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
	Tooltip
} from '@material-ui/core';
import TableContainer from "@material-ui/core/TableContainer";
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';
import ActionButton from './ActionButtons';



const withTooltip = (text, width) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: `${width}px`
		}}>
			{text}
		</div>
	</Tooltip >
)

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	}
});

const Results = ({ className, rows, columns, ...rest }) => {
	const classes = useStyles();
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);
	// const [data, setData] = React.useState(rows);

	const handleChangePage = (__even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	return (
		<Card
			className={clsx(classes.root, className)}
			{...rest}
		>
			<div style={{ height: '100%', width: '100%', background: 'white' }}>
				<TableContainer className={classes.container}>
					<Table stickyHeader aria-label="sticky table" size={'small'}>
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<TableCell
										key={column.field}
										// align={column.align}
										style={{
											minWidth: column.width
										}}
									>
										{column.headerName}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{
								rows && rows !== undefined && rows !== [] && rows !== null ?
									rows
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row) => {
											if (row.removed) return null;
											return (
												<TableRow hover key={row._id}>
													{columns.map((column) => {
														if (column.field === 'name') {
															return (
																<>
																	<TableCell key={column.field} align={column.align}>
																		<div style={{
																			display: 'flex',
																			flexGrow: '1'
																		}}>
																			<div style={{
																				width: '16px',
																				marginTop: '2px',
																				height: '16px',
																				borderRadius: '16px',
																				border: `3px solid ${row.polygon.properties.strokeColor}`,
																				marginRight: '10px'
																			}}>
																				<div style={{
																					opacity: '0.35',
																					width: '100%',
																					height: '100%',
																					borderRadius: '16px',
																					background: `${row.polygon.properties.fillColor}`,
																					marginRight: '10px'
																				}}>
																				</div>
																			</div>
																			{`${row.name}`}
																		</div>
																	</TableCell>
																</>
															)
														}
														if (column.field === 'actions') {
															return (
																<>
																	<TableCell key={column.field} align={column.align}>
																		<ActionButton row={row} />
																	</TableCell>
																</>
															)
														}
														const value = row[column.field];
														// console.log(column.field);
														return (
															<TableCell align={column.align}>
																{column.format && typeof value === "number"
																	? column.format(value)
																	: withTooltip(value, column.width)}
															</TableCell>
														);
													})}
												</TableRow>
											);
										})
									: <Typography>No Vehicles Found</Typography>
							}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10]}
					component="div"
					count={rows ? rows.length : 0}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
				{/* </Paper> */}
			</div>
		</Card >
	);
};

Results.propTypes = {
	className: PropTypes.string,
	rows: PropTypes.array.isRequired,
	columns: PropTypes.array.isRequired,
};

export default Results;
